import { XopowoPad } from './XopowoPad.js'

export const XopowoPadsContainer = props => {
  return (
    <div className="pads-container">
      <div className="padsRow">
        <XopowoPad id="pad1" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="Q" imgSrc={props.imgSrc} />
        <XopowoPad id="pad2" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="W" imgSrc={props.imgSrc} />
        <XopowoPad id="pad3" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="E" imgSrc={props.imgSrc} />
      </div>

      <div className="padsRow">
        <XopowoPad id="pad4" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="A" imgSrc={props.imgSrc} />
        <XopowoPad id="pad5" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="S" imgSrc={props.imgSrc} />
        <XopowoPad id="pad6" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="D" imgSrc={props.imgSrc} />
      </div>

      <div className="padsRow">
        <XopowoPad id="pad7" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="Z" imgSrc={props.imgSrc} />
        <XopowoPad id="pad8" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="X" imgSrc={props.imgSrc} />
        <XopowoPad id="pad9" handleClick={props.handleClick} handlePointer={props.handlePointer} accesKey="C" imgSrc={props.imgSrc} />
      </div>
    </div>
  )
}